import { Router } from '@resn/gozer-core/router';
import store from 'core/store';

export const navigate = (route) => {
    if (store().state.navigating) return;

    Router.navigate(route);
};
